export enum HierarchyItemIntendedMethodology {
  MaintenanceOptimization = 1,
  Rbi = 2,
  DataGathering = 3,
}
